import React, { useState } from 'react';
import { GitBranch, CheckCircle, XCircle } from 'lucide-react';
import UploadChangeDocument from './UploadChangeDocument';
import ChangeRequestList from './ChangeRequestList';
import ChangeReviewModal from './ChangeReviewModal';

interface ApprovalWorkflowProps {
  projectId: number;
}

const ApprovalWorkflow: React.FC<ApprovalWorkflowProps> = ({ projectId }) => {
  const [selectedChangeRequest, setSelectedChangeRequest] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleSelectChange = (changeRequest: any) => {
    setSelectedChangeRequest(changeRequest);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedChangeRequest(null);
  };

  const handleApproveReject = () => {
    // Refresh the list after approve/reject
    setRefreshTrigger(prev => prev + 1);
  };

  const handleUploadSuccess = (result: any) => {
    // Refresh the list after successful upload
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-super-dark-purple">Change Detection & Approval</h1>
          <p className="text-gray-600">Upload transcripts or documents to detect process changes and approve/reject them</p>
        </div>
      </div>

      {/* Upload Component */}
      <UploadChangeDocument projectId={projectId} onSuccess={handleUploadSuccess} />

      {/* Change Request List */}
      <ChangeRequestList
        projectId={projectId}
        onSelectChange={handleSelectChange}
        refreshTrigger={refreshTrigger}
      />

      {/* Review Modal */}
      <ChangeReviewModal
        changeRequest={selectedChangeRequest}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onApprove={handleApproveReject}
        onReject={handleApproveReject}
      />
    </div>
  );
};

export default ApprovalWorkflow;
